import { CollaboratorState } from './state';
import { collaboratorInitialState } from './initial-state';
import { CollaboratorActions } from './action-creators';
import * as actions from './actions';

export const collaboratorReducer = (
  state: CollaboratorState = collaboratorInitialState,
  action: CollaboratorActions
): CollaboratorState => {
  switch (action.type) {
    case actions.CREATE_COLLABORATOR_SUCCESS: {
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.collaborator.assetId]: {
            ...state.assets[action.collaborator.assetId],
            [action.collaborator.id]: action.collaborator,
          },
        },
      };
    }

    case actions.GET_COLLABORATORS_SUCCESS: {
      const newState: CollaboratorState = {
        ...state,
        assets: {
          ...state.assets,
        },
      };

      action.collaborators.forEach((collaborator) => {
        if (!(collaborator.assetId in newState.assets)) {
          newState.assets[collaborator.assetId] = {};
        }

        newState.assets[collaborator.assetId][collaborator.id] = collaborator;
      });

      return newState;
    }

    case actions.UPDATE_COLLABORATOR_ORDER: {
      const newState = {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
          },
        },
      };

      Object.keys(newState.assets[action.assetId]).forEach((collaboratorId) => {
        if (action.newOrder.includes(collaboratorId)) {
          newState.assets[action.assetId][collaboratorId] = {
            ...newState.assets[action.assetId][collaboratorId],
            order: action.newOrder.indexOf(collaboratorId),
          };
        }
      });

      return newState;
    }

    case actions.REMOVE_COLLABORATOR: {
      const newState: CollaboratorState = {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {},
        },
      };

      Object.values(state.assets[action.assetId]).forEach((collaborator) => {
        if (collaborator.id === action.collaboratorId) {
          return;
        }

        newState.assets[collaborator.assetId][collaborator.id] = {
          ...collaborator,
        };
      });

      return newState;
    }

    case actions.UPDATE_COLLABORATOR_FIELD: {
      return {
        ...state,
        assets: {
          ...state.assets,
          [action.assetId]: {
            ...state.assets[action.assetId],
            [action.collaboratorId]: {
              ...state.assets[action.assetId][action.collaboratorId],
              [action.field]: action.value,
            },
          },
        },
        updateStatus: 'modified',
      };
    }

    case actions.UPDATE_COLLABORATOR_SUCCESS: {
      if (action.oldCollaboratorId && action.collaborator.collaboratorId) {
        const assetCollaborators = state.assets[action.collaborator.assetId];
        assetCollaborators[action.collaborator.id] = action.collaborator;
        delete assetCollaborators[action.oldCollaboratorId];
        return {
          ...state,
          assets: {
            ...state.assets,
            [action.collaborator.assetId]: assetCollaborators,
          },
          updateStatus: 'saved',
        };
      }
      return {
        ...state,
        updateStatus: 'saved',
      };
    }

    case actions.CLEAR_COLLABORATOR_STATE: {
      return collaboratorInitialState;
    }

    default: {
      return { ...state };
    }
  }
};
